<template>
  <Container type="card-full">
    <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick" :btnLoading="btnLoading"></menu-btn>
    </div>
    <vggrid ref="xGrid" :list="list" tableheight="700" flexname=""
            :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total"
            :needBlackRow="false"
            @cellClick="cellClick"  @cellDblClick="cellDblClick" @pagechange="pagechange">
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'rmivdIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        doctid: this.$route.query.doctid,
        list: [],
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'rmivdno', fieldtype: 'C', title: '单号',calculExpr:''},
          { field: 'rmivddate', fieldtype: 'C', title: '日期',calculExpr:'',formatter:['toDateString', 'yyyy-MM-dd']},
          { field: 'cvname', fieldtype: 'C', title: '供应商',calculExpr:''},
          { field: 'docstatcheckstatusname', fieldtype: 'C', title: '状态',calculExpr:''},
          { field: 'docstatnextcheckdesc', fieldtype: 'C', title: '下一处理',calculExpr:''},
          { field: 'rmivdremark', fieldtype: 'C',title: '备注',calculExpr:''}
        ],
        rmivd: {},
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          currPage: 1,
          pageSize: 20
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addRmivd())
      this.$on('CHG', () => this.chgRmivd())
      this.$on('DEL', () => this.delRmivd())
      this.$on('CHECK', () => this.checkDoc())
      this.$on('UNCHECK', () => this.unCheckDoc())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.init()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
        this.getPageList()
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      async init(){
        this.menuid = this.$route.query.menuid
        this.doctid = this.$route.query.doctid
        this.list = []
        this.btnLoading = false
        this.rmivd = {}
        // console.log(this.$route.query)
      },
      btnClick (code) {
        this.$emit(code)
      },
      async addRmivd () {
        let rmivdno = await request({
          url: '/kfgl/doct/genDocno',
          method: "post",
          data: {comid: this.$store.getters.loginUser.usercomid,doctid: this.doctid, genflg: 0}
        })
        this.$router.push({name: 'rmivdForm', params: {form: {rmivdid: 0, rmivddoctid:this.doctid,rmivdno: rmivdno,comid: this.$store.getters.loginUser.usercomid,docstatcheckval:1}, type: 1}})
      },
      async chgRmivd () {
        this.$router.push({name: 'rmivdForm', params: {form: this.rmivd, type: 2}})
      },
      async delRmivd () {
        if (this.rmivd.docstatcheckval !== 1) {
          this.$message.warning('单据已审核，不能删除!')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/cggl/rmivd/delRmivd',
            method: "post",
            data: this.rmivd
          })
          // console.log(data)
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！（'+data.msg+')')
          }
        })
      },
      async cellClick (row) {
        this.rmivd = row.row
      },
      async cellDblClick (row) {
        this.rmivd = row.row
        this.$router.push({name: 'rmivdForm', params: {form: this.rmivd, type: 3}})
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async pagechange (rmivdPage) {
        this.query.currPage = rmivdPage.currentPage
        this.query.pageSize = rmivdPage.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/cggl/rmivd/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      },
      async checkDoc () {
        if (!this.rmivd.rmivdid) {
          this.$message.warning('请选择一条数据!')
          return
        }
        this.btnLoading = true
        let data = await request({
          url: '/xtgl/docstat/checkDoc',
          method: "post",
          data: {doctid: this.rmivd.rmivddoctid,
            docid: this.rmivd.rmivdid,
            doctablename: 'rmivdrec',
            docidfield: 'rmivdid',
            fmon: this.rmivd.rmivdfmon,
            userid: this.$store.getters.loginUser.userid}
        })
        // console.log(data)
        if (data.issuccess === 1) {
          await this.getPageList()
          this.btnLoading = false
          this.$message.success(data.msg)
        } else {
          this.btnLoading = false
          this.$message.error('审核失败,'+ data.msg)
        }
      },
      // 反审核
      async unCheckDoc () {
        if (!this.rmivd.rmivdid) {
          this.$message.warning('请选择一条数据!')
          return
        }
        this.btnLoading = true
        let data = await request({
          url: '/xtgl/docstat/unCheckDoc',
          method: "post",
          data: {doctid: this.rmivd.rmivddoctid,
            docid: this.rmivd.rmivdid,
            doctablename: 'rmivdrec',
            docidfield: 'rmivdid',
            fmon: this.rmivd.rmivdfmon,
            userid: this.$store.getters.loginUser.userid}
        })
        if (data.issuccess === 1) {
          await this.getPageList()
          this.btnLoading = false
          this.$message.success(data.msg)
        } else {
          this.btnLoading = false
          this.$message.error('反审核失败,'+ data.msg)
        }
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
